export default "__VITE_ASSET__CMott$jj__"